export default function ChoiceBubble({
  onSend,
  array,
}: {
  onSend: (text: string) => void;
  array: string[];
}) {
  return (
    <div className="vcw-additionnal-message-container">
      {array.map((el, idx) => (
        <button key={idx} className="vcw-yes-btn" onClick={() => onSend(el)}>
          {el}
        </button>
      ))}
    </div>
  );
}
